export interface MovieItem {
  id: string;
  title: string;
  kind: '电影';
  year: string;
  genres: string[];
  region: string;
  rating: number;
  duration: string;
  summary: string;
  poster: string;
}

export const latestMovies: MovieItem[] = [
  {
    id: 'movie-01',
    title: '荒野拾光',
    kind: '电影',
    year: '2026',
    genres: ['剧情', '冒险'],
    region: '中国大陆',
    rating: 8.6,
    duration: '128 分钟',
    summary:
      '一支纪录团队深入无人区，寻找一位传说中的护林人。镜头记录下荒原光影的更替，也记录下人与自然之间漫长而温柔的对话。',
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20poster%20illustration%20of%20a%20lone%20ranger%20walking%20across%20a%20golden%20wilderness%20at%20dusk%2C%20warm%20amber%20and%20deep%20crimson%20color%20palette%2C%20dramatic%20rim%20lighting%2C%20minimal%20clean%20composition%2C%20rich%20texture%20high%20detail%20elegant%20negative%20space&width=400&height=600&seq=xc-movie-01&orientation=portrait',
  },
  {
    id: 'movie-02',
    title: '星轨之外',
    kind: '电影',
    year: '2025',
    genres: ['科幻', '冒险'],
    region: '中国大陆',
    rating: 8.9,
    duration: '142 分钟',
    summary:
      '近未来，一艘远航飞船在返回途中偏离既定轨道。船员们必须在有限的能源里重新计算回家的路线，也重新理解“家”的含义。',
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20poster%20illustration%20of%20a%20deep%20space%20vessel%20drifting%20past%20a%20warm%20glowing%20planet%2C%20amber%20and%20crimson%20color%20palette%2C%20dramatic%20light%20rays%2C%20minimal%20elegant%20composition%2C%20rich%20texture%20high%20detail%20clean%20negative%20space&width=400&height=600&seq=xc-movie-02&orientation=portrait',
  },
  {
    id: 'movie-03',
    title: '长夜将尽',
    kind: '电影',
    year: '2025',
    genres: ['悬疑', '犯罪'],
    region: '中国香港',
    rating: 8.3,
    duration: '118 分钟',
    summary:
      '一名即将退休的警探接手最后一桩旧案。随着线索一点点拼合，他发现真相并非藏在案发现场，而是藏在每个人回避的记忆里。',
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20moody%20poster%20illustration%20of%20a%20rainy%20night%20city%20street%20with%20a%20single%20street%20lamp%20glow%2C%20warm%20amber%20and%20deep%20maroon%20tones%2C%20dramatic%20contrast%20lighting%2C%20minimal%20composition%2C%20high%20detail%20film%20grain&width=400&height=600&seq=xc-movie-03&orientation=portrait',
  },
  {
    id: 'movie-04',
    title: '夏日来信',
    kind: '电影',
    year: '2026',
    genres: ['爱情', '剧情'],
    region: '中国大陆',
    rating: 7.9,
    duration: '112 分钟',
    summary:
      '小城邮局的旧信箱里，两封相隔二十年的信被同时投递。读信的人循着字迹，走回那个蝉鸣不止的夏天。',
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20romantic%20poster%20illustration%20of%20a%20sunlit%20coastal%20town%20with%20old%20mailboxes%20by%20the%20sea%2C%20warm%20amber%20peach%20and%20soft%20rose%20tones%2C%20gentle%20afternoon%20light%2C%20minimal%20airy%20composition%2C%20high%20detail&width=400&height=600&seq=xc-movie-04&orientation=portrait',
  },
  {
    id: 'movie-05',
    title: '山海图志',
    kind: '电影',
    year: '2025',
    genres: ['动画', '奇幻'],
    region: '中国大陆',
    rating: 9.1,
    duration: '106 分钟',
    summary:
      '少年为修补一卷残缺的山海图踏上旅途，沿途遇见会说话的异兽与沉默的古神。画中世界的边界，正由他的选择一笔笔改写。',
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20animated%20poster%20illustration%20of%20mythical%20mountains%20and%20sea%20dragons%20in%20an%20ancient%20scroll%20style%2C%20warm%20amber%20gold%20and%20crimson%20tones%2C%20glowing%20mist%2C%20ornate%20elegant%20composition%2C%20rich%20high%20detail&width=400&height=600&seq=xc-movie-05&orientation=portrait',
  },
  {
    id: 'movie-06',
    title: '逆流而上',
    kind: '电影',
    year: '2026',
    genres: ['剧情', '运动'],
    region: '中国大陆',
    rating: 8.2,
    duration: '124 分钟',
    summary:
      '一支解散多年的业余赛艇队重新集结，为一场几乎不可能赢的比赛备战。他们训练的不只是速度，还有重新相信彼此的能力。',
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20sports%20poster%20illustration%20of%20rowers%20cutting%20through%20morning%20mist%20on%20a%20river%2C%20warm%20amber%20sunrise%20and%20deep%20rust%20tones%2C%20dynamic%20rhythm%2C%20minimal%20clean%20composition%2C%20high%20detail&width=400&height=600&seq=xc-movie-06&orientation=portrait',
  },
  {
    id: 'movie-07',
    title: '无声之城',
    kind: '电影',
    year: '2025',
    genres: ['悬疑', '惊悚'],
    region: '韩国',
    rating: 8.5,
    duration: '121 分钟',
    summary:
      '整座城市在一夜之间失去声音。记者循着仅存的文字线索追查下去，却发现沉默本身就是一场精心设计的局。',
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20thriller%20poster%20illustration%20of%20a%20silent%20empty%20city%20crossing%20at%20dawn%20in%20heavy%20fog%2C%20warm%20amber%20streetlights%20against%20deep%20crimson%20shadows%2C%20tense%20minimal%20composition%2C%20high%20detail&width=400&height=600&seq=xc-movie-07&orientation=portrait',
  },
  {
    id: 'movie-08',
    title: '烟火人间',
    kind: '电影',
    year: '2026',
    genres: ['剧情', '家庭'],
    region: '中国大陆',
    rating: 8.0,
    duration: '115 分钟',
    summary:
      '一条老街上的四户人家，在同一顿年夜饭里各自藏着心事。烟火升起时，他们终于愿意把话说完。',
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20warm%20poster%20illustration%20of%20an%20old%20lane%20lit%20by%20red%20lanterns%20during%20a%20festive%20evening%2C%20amber%20gold%20and%20crimson%20tones%2C%20cozy%20soft%20light%2C%20minimal%20elegant%20composition%2C%20high%20detail&width=400&height=600&seq=xc-movie-08&orientation=portrait',
  },
];